export const ERROR = 'ERROR'
export const AUTH_COMPLETED = 'AUTH_COMPLETED'
export const AUTH_FAILED = 'AUTH_FAILED'
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING'
export const SIGNED_OUT = 'SIGNED_OUT'
export const SET_ITEMS_ON_PAGE = 'SET_ITEMS_ON_PAGE'

export const SET_USERS = 'SET_USERS'
export const SET_USERS_LOADING = 'SET_USERS_LOADING'
export const SET_USERS_PAGE = 'SET_USERS_PAGE'
export const SET_USER = 'SET_USER'
export const SET_USER_LOADING = 'SET_USER_LOADING'

export const SET_SITES = 'SET_SITES'
export const SET_SITES_PAGE = 'SET_SITES_PAGE'
export const SET_SITES_LOADING = 'SET_SITES_LOADING'
export const SET_SITE = 'SET_SITE'
export const SET_SITE_LOADING = 'SET_SITE_LOADING'

export const SET_POSITIONS_LOADING = 'SET_POSITIONS_LOADING'
export const SET_KEYWORDS = 'SET_KEYWORDS'
export const SET_POSITIONS = 'SET_POSITIONS'

export const SET_HINTS = 'SET_HINTS'
export const SET_HINTS_LOADING = 'SET_HINTS_LOADING'